module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/auth/auth.component.html
// module id = ./src/app/views/auth/auth.component.html
// module chunks = main